<div
  fxLayout="row"
  fxLayoutGap="10px"
  fxLayoutAlign="start center"
  fxLayout.lt-lg="column"
  fxLayoutAlign.lt-lg="none none"
  style="border-bottom: 1px solid gray; padding: 10px 0px; min-height: 60px"
>
  <!-- title -->
  <div fxFlex="grow" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
    <div style="word-break: break-word">
      <h3 style="margin: 0px">{{ title }}</h3>
    </div>
    <app-info-button [tooltip]="tooltip"></app-info-button>
  </div>

  <!-- visiblity select -->
  <div
    fxFlex.gt-md="30"
    fxLayout="row"
    fxLayoutAlign="start center"
    fxLayoutGap="10px"
    *ngIf="baseDataObject"
    [style.display]="editdisabled || edit ? 'none' : 'flex'"
  >
    <div
      matTooltip="Privatsphäreeinstellung: Hier kannst Du auswählen, ob dieser Bereich nur für dich oder für alle Mitglieder sichtbar ist."
    >
      <i class="far fa-lock"></i>
    </div>
    <div fxFlex="grow">
      <mat-checkbox
        *ngIf="checkbox"
        [(ngModel)]="baseDataObject[privacyUserAttributeName]"
        (change)="savePrivacy()"
        [disabled]="disableNicknameOnly"
        matTooltip="Kann nur ausgewählt werden wenn ein Nickname gespeichert ist."
      >
        Nickname benutzen
      </mat-checkbox>

      <mat-select
        *ngIf="!checkbox"
        [(ngModel)]="baseDataObject[privacyUserAttributeName]"
        name="privacy"
        (selectionChange)="savePrivacy()"
      >
        <mat-option [value]="false">für alle</mat-option>
        <mat-option [value]="true">nur ich</mat-option>
      </mat-select>
    </div>
  </div>

  <!-- edit -->
  <div
    *ngIf="!edit && save && !editdisabled"
    fxLayout="row"
    fxLayoutAlign="start center"
    fxLayoutGap="10px"
    style="cursor: pointer"
    (click)="startEdit()"
  >
    <button
      fxLayout="row"
      fxLayoutGap="10px"
      fxLayoutAlign="start center"
      [disabled]="editdisabled"
      class="mobileGrowBtn"
    >
      <i class="far fa-edit"></i>
      <div>Bearbeiten</div>
    </button>
  </div>

  <!-- save -->
  <div *ngIf="edit && save">
    <button
      fxLayout="row"
      fxLayoutGap="10px"
      fxLayoutAlign="start center"
      class="mobileGrowBtn"
      (click)="onSaveButton()"
    >
      <i class="far fa-save"></i>
      <div>Speichern</div>
    </button>
  </div>

  <!-- cancel -->
  <div
    *ngIf="edit && save"
    fxLayout="row"
    fxLayoutAlign="start center"
    fxLayoutGap="10px"
    style="cursor: pointer"
    (click)="onCancelButton()"
  >
    <button fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center" class="mobileGrowBtn">
      <i class="fas fa-times"></i>
      <div>Abbrechen</div>
    </button>
  </div>
</div>
